import { render, staticRenderFns } from "./consultationDetailDialog.vue?vue&type=template&id=ecb780aa&scoped=true"
import script from "./consultationDetailDialog.vue?vue&type=script&lang=js"
export * from "./consultationDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./consultationDetailDialog.vue?vue&type=style&index=0&id=ecb780aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb780aa",
  null
  
)

export default component.exports